import React from 'react';
import { Star, CheckCircle } from 'lucide-react';
const featuredTestimonial = {
  name: 'Daniela y Facundo',
  location: 'Moreno, Buenos Aires',
  quote: 'Teníamos el terreno hace tres años y siempre encontrábamos una excusa para no arrancar. Con el Tomo 1 entendimos que podíamos empezar con 35m² y crecer en etapas. Hoy estamos en el Tomo 3.'
};
export function TestimonialsCarousel() {
  return <section className="py-12 bg-white" data-id="element-347">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-348">
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-md border-l-4 border-l-gold border-y border-r border-gray-100 relative" data-id="element-349">
          <div className="flex text-gold mb-4" data-id="element-350">
            {[...Array(5)].map((_, idx) => <Star key={idx} className="w-5 h-5 fill-current" data-id="element-351" />)}
          </div>
          <p className="text-gray-800 text-lg md:text-xl font-medium leading-relaxed mb-6" data-id="element-352">
            "{featuredTestimonial.quote}"
          </p>
          <div className="flex items-center gap-3" data-id="element-353">
            <div className="w-12 h-12 rounded-full bg-beige-dark flex items-center justify-center text-charcoal font-serif font-bold text-xl" data-id="element-354">
              DF
            </div>
            <div data-id="element-355">
              <div className="flex items-center gap-1.5" data-id="element-356">
                <p className="text-base font-bold text-charcoal" data-id="element-357">
                  {featuredTestimonial.name}
                </p>
                <CheckCircle className="w-4 h-4 text-green-600" data-id="element-358" />
              </div>
              <p className="text-sm text-gray-500" data-id="element-359">
                {featuredTestimonial.location} • Compra verificada
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}